export function getStoredTheme(): 'dark' | 'light' {
  try {
    const t = localStorage.getItem('bingo_theme');
    if (t === 'light') return 'light';
    return 'dark';
  } catch {
    return 'dark';
  }
}

export function setStoredTheme(theme: 'dark' | 'light') {
  try {
    localStorage.setItem('bingo_theme', theme);
  } catch {}
}
